import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M39.882 22.173 17.95.104a19.8 19.8 0 0 0-2.9.514C6.4 2.82 0 20 0 20s28 18.737 31.194 16.575c.64-.432 1.252-.9 1.836-1.402l-13-13h19.852Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M34.783 20 15.332.55C6.538 2.651 0 10.561 0 20c0 11.046 8.954 20 20 20 4.19 0 8.078-1.29 11.291-3.491L14.783 20h20Z"
}, null, -1), h = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "m17.391 11.092-1.776-.835.946-1.72-1.93.368-.244-1.949-1.344 1.434L11.7 6.956l-.245 1.95-1.929-.37.946 1.72-1.776.836h-.87a5.217 5.217 0 0 0 10.435 0h-.87Zm1.63 18.438-2.442-1.148 1.3-2.366-2.652.508-.336-2.68-1.848 1.97-1.847-1.97-.336 2.68-2.652-.508 1.3 2.366-2.442 1.149 2.442 1.149-1.3 2.365 2.652-.507.336 2.68 1.848-1.972 1.847 1.971.336-2.68 2.652.508-1.3-2.365 2.442-1.15Z"
}, null, -1), d = [
  n,
  s,
  c,
  h
];
function i(_, a) {
  return e(), l("svg", o, [...d]);
}
const p = { render: i };
export {
  p as default,
  i as render
};
